import { getPreviousDate, stringToDate } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { digitalShelfEvolutionChartCurrentPeriod, digitalShelfSubmittedFilters } from "../@signals"


export const rangeDatesDigitalShelf = [{
	label: 'Yesterday',
	value: () => {
		return [getPreviousDate({ days: 1 }, digitalShelfSubmittedFilters.value.endDate), getPreviousDate({ days: 1 }, digitalShelfSubmittedFilters.value.endDate)]
	},
	placement: 'left',
	onFocus: () => digitalShelfEvolutionChartCurrentPeriod.value = DATE_PERIODS.YESTERDAY
}, {
	label: 'Last 7 Days',
	value: () => {
		return [getPreviousDate({ days: 6 }, digitalShelfSubmittedFilters.value.endDate), getPreviousDate({ days: 0 }, digitalShelfSubmittedFilters.value.endDate)]
	},
	placement: 'left',
	onFocus: () => digitalShelfEvolutionChartCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS
}, {
	label: 'Last 30 Days',
	value: () => {
		return [getPreviousDate({ days: 29 }, digitalShelfSubmittedFilters.value.endDate), getPreviousDate({ days: 0 }, digitalShelfSubmittedFilters.value.endDate)]
	},
	placement: 'left',
	onFocus: () => digitalShelfEvolutionChartCurrentPeriod.value = DATE_PERIODS.LAST_30_DAYS
}, {
	label: 'Last Month',
	value: () => {
		return [
			getPreviousDate({ months: 1 }, new Date(stringToDate(digitalShelfSubmittedFilters.value.endDate).setDate(1))), 
			getPreviousDate({ days: 1 }, new Date(stringToDate(digitalShelfSubmittedFilters.value.endDate).setDate(1)))
		]
	},
	placement: 'left',
	onFocus: () => digitalShelfEvolutionChartCurrentPeriod.value = DATE_PERIODS.LAST_MONTH
}]